module.exports = __webpack_public_path__ + "static/xian@large-2cc5c25919ae3abbf6450c6c8933c427.jpg";